import { Dialog } from "@blueprintjs/core";
import React from "react";
import { GeneratorType } from "types/generatorType";
import { RegionType } from "types/regionType";
import { ScreeningView } from "types/screeningViewType";
import RegionSelectorCard from "./RegionSelectorCard";

type ChangeRegionDialogProps = {
    readonly isOpen: boolean;
    readonly closeDialog: () => void;
    readonly currentRegionAndGeneratorType?: {
        readonly region: RegionType;
        readonly generatorType: GeneratorType;
    };
    readonly currentScreeningView?: ScreeningView;
};

const ChangeRegionDialog: React.FC<ChangeRegionDialogProps> = (props) => {
    const {
        isOpen,
        closeDialog,
        currentRegionAndGeneratorType,
        currentScreeningView
    } = props;

    return (
        <Dialog
            isOpen={isOpen}
            title={"Change region"}
            onClose={closeDialog}
            icon="globe"
        >
            <RegionSelectorCard
                onNavigate={closeDialog}
                currentRegionAndGeneratorType={currentRegionAndGeneratorType}
                currentScreeningView={currentScreeningView}
            />
        </Dialog>
    );
};

export default ChangeRegionDialog;
